import { IconSvgProps } from '../types';

export const Webhook = ({ size }: IconSvgProps) => (
  <svg
    id="icon-software-webhook"
    width={size}
    height={size}
    viewBox="0 0 65 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor" fillRule="nonzero">
        <g>
          <circle
            opacity="0.5"
            transform="translate(15.600000, 49.100000) rotate(90.000000) translate(-15.600000, -49.100000) "
            cx="15.6"
            cy="49.1"
            r="15.3124"
          />
          <circle
            opacity="0.5"
            transform="translate(49.460000, 49.400000) rotate(90.000000) translate(-49.460000, -49.400000) "
            cx="49.46"
            cy="49.4"
            r="15.3124"
          />
          <circle
            opacity="0.5"
            transform="translate(32.290000, 16.000000) rotate(90.000000) translate(-32.290000, -16.000000) "
            cx="32.29"
            cy="16"
            r="15.3124"
          />
          <path d="M25.96,49.1 C25.96,54.8 21.32,59.5 15.6,59.5 C9.88,59.5 5.24,54.8 5.24,49.1 C5.24,46.4 6.28,43.9 8.1,42 C9,41 10.51,41 11.46,41.9 C12.38,42.8 12.44,44.2 11.62,45.2 L11.54,45.3 C10.55,46.3 9.99,47.7 9.99,49.1 C9.99,52.2 12.5,54.7 15.6,54.7 C18.64,54.7 21.12,52.3 21.2,49.3 L21.2,49.1 C21.2,47.8 22.27,46.7 23.58,46.7 C24.89,46.7 25.96,47.8 25.96,49.1 Z" />
          <path d="M52.08,48.9 C52.08,50.2 51.07,51.2 49.81,51.2 L49.7,51.3 L23.58,51.3 C22.27,51.3 21.2,50.2 21.2,48.9 C21.2,47.6 22.21,46.6 23.47,46.5 L23.58,46.5 L49.7,46.5 C51.01,46.5 52.08,47.6 52.08,48.9 Z" />
          <circle
            transform="translate(49.460000, 49.100000) rotate(90.000000) translate(-49.460000, -49.100000) "
            cx="49.46"
            cy="49.1"
            r="3.86959"
          />
          <circle
            transform="translate(32.050000, 16.000000) rotate(90.000000) translate(-32.050000, -16.000000) "
            cx="32.05"
            cy="16"
            r="3.86959"
          />
          <circle
            transform="translate(15.600000, 49.100000) rotate(90.000000) translate(-15.600000, -49.100000) "
            cx="15.6"
            cy="49.1"
            r="3.86959"
          />
          <path d="M47.7,40.3 C48.3,41.4 47.86,42.9 46.69,43.5 C45.57,44.1 44.18,43.7 43.54,42.6 L43.49,42.5 L30.18,17.1 C29.57,15.9 30.02,14.5 31.19,13.9 C32.31,13.3 33.7,13.7 34.34,14.8 L34.39,14.9 L47.7,40.3 Z" />
          <path d="M59.85,49.4 C59.85,55.1 55.21,59.7 49.49,59.7 C46.73,59.7 44.13,58.6 42.2,56.7 C41.27,55.8 41.26,54.3 42.19,53.4 C43.08,52.4 44.52,52.4 45.46,53.3 L45.55,53.3 C46.59,54.4 47.99,55 49.49,55 C52.59,55 55.1,52.5 55.1,49.4 C55.1,46.3 52.67,43.8 49.65,43.8 L49.49,43.8 L45.59,43.8 C44.28,43.8 43.21,42.7 43.21,41.4 C43.21,40.1 44.22,39.1 45.48,39 L45.59,39 L49.49,39 C55.21,39 59.85,43.6 59.85,49.4 Z" />
          <path d="M42.64,16 C42.64,17.3 41.58,18.4 40.27,18.4 C38.99,18.4 37.95,17.4 37.89,16.1 L37.89,16 C37.89,12.9 35.38,10.4 32.29,10.4 C29.19,10.4 26.68,12.9 26.68,16 C26.68,18.1 27.89,20 29.75,21 L29.9,21.1 C31.08,21.6 31.59,23 31.03,24.2 C30.47,25.4 29.05,25.9 27.87,25.4 C24.27,23.7 21.93,20 21.93,16 C21.93,10.3 26.57,5.6 32.29,5.6 C38.01,5.6 42.64,10.3 42.64,16 Z" />
          <path d="M30.03,21.2 C31.16,21.8 31.64,23.2 31.13,24.3 L31.08,24.4 L17.96,50.4 C17.37,51.6 15.95,52.1 14.77,51.5 C13.64,50.9 13.16,49.5 13.67,48.4 L13.72,48.3 L26.84,22.3 C27.43,21.1 28.86,20.6 30.03,21.2 Z" />
        </g>
      </g>
    </g>
  </svg>
);
